import { useEffect, useState } from "react";
import { Check, Shapes } from "lucide-react";
import api from "@/lib/api";

/** أساليب الشعارات المرجعية (خط رفيع، مونوغرام، ختم، ريترو، فخامة…) — يختار العميل الأسلوب الأقرب لذوقه قبل المقترحات، فتتبعه المقترحات الثلاثة والتوليد النهائي. */
export const LogoStylePicker = ({ value = "", onChange }) => {
  const [styles, setStyles] = useState([]);
  useEffect(() => { api.get("/public/logo-styles").then((r) => setStyles(r.data || [])).catch(() => setStyles([])); }, []);
  if (!styles.length) return null;
  return (
    <div className="rounded-xl border border-border bg-background/70 p-3 space-y-2" data-testid="logo-style-picker">
      <p className="text-xs font-bold flex items-center gap-1.5"><Shapes className="w-4 h-4 text-primary" /> أسلوب الشعار (اختياري): اختر الأقرب لذوقك — تتبعه المقترحات والتوليد النهائي</p>
      <div className="flex flex-wrap gap-1.5">
        <button type="button" onClick={() => onChange("")} data-testid="logo-style-any"
          className={`rounded-full border px-2.5 py-1 text-[11px] transition-colors ${!value ? "border-primary bg-primary/10 font-bold" : "border-border hover:border-primary/40"}`}>
          {!value && <Check className="inline w-3 h-3 text-primary ml-0.5" />}دع المدير الإبداعي يختار
        </button>
        {styles.map((s) => {
          const active = value === s.key;
          return (
            <button type="button" key={s.key} onClick={() => onChange(active ? "" : s.key)} title={s.desc} data-testid={`logo-style-${s.key}`}
              className={`rounded-full border px-2.5 py-1 text-[11px] transition-colors ${active ? "border-primary bg-primary/10 font-bold" : "border-border hover:border-primary/40"}`}>
              {active && <Check className="inline w-3 h-3 text-primary ml-0.5" />}{s.name}
            </button>
          );
        })}
      </div>
      {value && <p className="text-[11px] text-muted-foreground" data-testid="logo-style-desc">{styles.find((s) => s.key === value)?.desc}</p>}
    </div>
  );
};
